import React from 'react';
import { Loader2, Plus, Trash2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Textarea } from '../../../components/ui/textarea';
import { genUid } from '../leadUtils';

export const FaqsCard = ({ content, setContent, save, saving }) => {
  const setFaq = (i, k) => (e) => {
    setContent((c) => {
      const faqs = [...c.faqs];
      faqs[i] = { ...faqs[i], [k]: e.target.value };
      return { ...c, faqs };
    });
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-display font-semibold text-lg">FAQs</h3>
          <p className="text-sm text-muted-foreground mt-1">Keep answers concise. Avoid unverified claims.</p>
        </div>
        <Button
          variant="outline"
          size="sm"
          data-testid="admin-content-add-faq-button"
          onClick={() => setContent((c) => ({ ...c, faqs: [...c.faqs, { _uid: genUid('ct'), q: '', a: '' }] }))}
        >
          <Plus className="w-4 h-4 mr-1" /> Add
        </Button>
      </div>
      <div className="mt-5 space-y-4">
        {content.faqs.map((f, i) => (
          <div key={f._uid} className="border border-border rounded-lg p-4" data-testid={`admin-content-faq-${i}`}>
            <div className="flex gap-2">
              <Input placeholder="Question" value={f.q} onChange={setFaq(i, 'q')} className="h-10 flex-1" data-testid={`admin-content-faq-question-${i}`} />
              <Button
                variant="outline"
                size="icon"
                className="h-10 w-10 shrink-0 text-destructive"
                aria-label="Delete FAQ"
                data-testid={`admin-content-faq-delete-${i}`}
                onClick={() => setContent((c) => ({ ...c, faqs: c.faqs.filter((_, j) => j !== i) }))}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
            <Textarea placeholder="Answer" value={f.a} onChange={setFaq(i, 'a')} className="mt-2 min-h-[60px]" />
          </div>
        ))}
      </div>
      <Button className="h-10 mt-5" disabled={saving === 'faqs'} onClick={() => save('faqs')} data-testid="admin-content-faqs-save-button">
        {saving === 'faqs' ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
        Save FAQs
      </Button>
    </div>
  );
};
